import React from 'react';
export function Footer() {
  return <footer className="bg-graphite px-3 py-3 text-center sm:px-6" data-id="element-65" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-2xl" data-id="element-66" data-mp="3gfiyctkyyvje">
        <p className="text-[0.62rem] leading-[1.35] text-white/70 sm:text-[0.7rem]" data-id="element-67" data-mp="3ghc323c0v5or">
          © 2026 RADIOLOGY VISUAL ATLAS™ — All Rights Reserved. RADIOLOGY VISUAL
          ATLAS™ is an educational study and reference resource. It does not
          replace formal radiology education, clinical training, professional
          medical advice, diagnosis or qualified clinical judgment.
        </p>
        <p className="mt-1 font-body text-[0.6rem] font-bold uppercase tracking-wide text-white/60 sm:text-[0.68rem]" data-id="element-68" data-mp="36msyjwt2ysh">
          Terms &amp; Conditions • Privacy Policy • Contact Support:{' '}
          <a href="mailto:kitonline27@gmail.com" className="text-gold underline-offset-2 hover:underline" data-id="element-69" data-mp="3qblzbw434o4r">
            kitonline27@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}